export interface Activity {
  title?: string;
  type: ActivityType;
  customEmissionFactorId?: string;
  hours?: number;
  days?: number;
  kilometers?: number;
  peoplePerVehicle?: number;
  scheduledDays?: number[];
  activityImpactDetail?: {
    impact: number;
  };
  customEmissionFactor?: { name: string };
}
export enum ActivityType {
  Helico = 'helico',
  JetFlight = 'jetFlight',
  ScenicFlight = 'scenicFlight',
  Outboard = 'outboard',
  SmallMotorisedBoat = 'smallMotorisedBoat',
  CityTrain = 'cityTrain',
  SteamTrain = 'steamTrain',
  JetboatOrJetski = 'jetboatOrJetski',
  MotorisedSailingBoat = 'motorisedSailingBoat',
  MotorisedCatamaran = 'motorisedCatamaran',
  NavetteFluviale = 'navetteFluviale',
  NavetteMaritime = 'navetteMaritime',
  Moto = 'moto',
  Quad = 'quad',
  FourByFourSafari = 'fourByFourSafari',
  Telecabine = 'telecabine',
  Telepherique = 'telepherique',
  Snowscooter = 'snowscooter',
  DogSled = 'dogSled',
  HotAirBalloon = 'hotAirBalloon',
  CulturalActivity = 'culturalActivity',
  KayakCanoePackraftDhow = 'kayakCanoePackraftDhow',
  Surfing = 'surfing',
  WalkingTrailRunningCyclingSnorkeling = 'walkingTrailRunningCyclingSnorkeling',
  Festival = 'festival',
  Climbing = 'climbing',
  // Croisiere = 'croisiere',
  Ski = 'ski',
  SkiDeRandonneeSansRemontees = 'skiDeRandonneeSansRemontees',
  CustomFactor = 'custom',
}
// J'ai récupéré ça de l'ancien formulaire, mais je suis pas sur qu'on en a besoin. je le commente en attendant
// On pourra le supprimer une fois que le formulaire activité sera fini
// export interface ActivityFormData {
//   type: ActivityType;
//   hours?: number;
//   minutes?: number;
//   days?: number;
//   kilometers?: number;
//   distance?: number;
//   peoplePerVehicle?: number;
//   scheduledDays?: number[];
// }

/**
 * Activités à impact zéro qui n'ont pas besoin de valeurs de durée ou distance
 */
export const ZERO_IMPACT_ACTIVITIES = [
  ActivityType.KayakCanoePackraftDhow,
  ActivityType.Surfing,
  ActivityType.WalkingTrailRunningCyclingSnorkeling,
  ActivityType.Climbing,
  ActivityType.SkiDeRandonneeSansRemontees,
];

/**
 * Activités sportives à impact zéro
 */
export const ZERO_IMPACT_SPORT_ACTIVITIES = [
  ActivityType.WalkingTrailRunningCyclingSnorkeling,
  ActivityType.KayakCanoePackraftDhow,
  ActivityType.Surfing,
  ActivityType.Climbing,
];

/**
 * Activités qui utilisent uniquement la durée (pas de distance)
 */
export const DURATION_ONLY_ACTIVITIES = [
  ActivityType.Helico,
  ActivityType.ScenicFlight,
  ActivityType.Outboard,
  ActivityType.SmallMotorisedBoat,
  ActivityType.JetboatOrJetski,
  ActivityType.MotorisedSailingBoat,
  ActivityType.MotorisedCatamaran,
  ActivityType.Quad,
  ActivityType.Snowscooter,
  ActivityType.CulturalActivity,
  ActivityType.KayakCanoePackraftDhow,
  ActivityType.Surfing,
  ActivityType.WalkingTrailRunningCyclingSnorkeling,
  ActivityType.Climbing,
  ActivityType.HotAirBalloon,
];

/**
 * Activités qui utilisent des jours plutôt que des heures
 */
export const DURATION_DAYS_ACTIVITIES = [
  ActivityType.Ski,
  ActivityType.SkiDeRandonneeSansRemontees,
  // ActivityType.Croisiere,
  ActivityType.Festival,
];

/**
 * Activités qui nécessitent un nombre de personnes par véhicule
 */
export const PEOPLE_PER_VEHICLE_ACTIVITIES = [
  ActivityType.MotorisedSailingBoat,
  ActivityType.FourByFourSafari,
];

/**
 * Nombre maximum de personnes par véhicule, par type d'activité
 * Un 4x4 de safari ne dépasse pas 10 places ; les bateaux ne sont pas plafonnés.
 */
export const MAX_PEOPLE_PER_VEHICLE: Partial<Record<ActivityType, number>> = {
  [ActivityType.FourByFourSafari]: 10,
};

/**
 * Activités dont le facteur d'émission est exprimé au km : seule la distance
 * est demandée, aucun choix distance/durée n'est proposé
 */
export const DISTANCE_ONLY_ACTIVITIES = [ActivityType.Telepherique];

/**
 * Activités au forfait : le facteur correspond à une sortie complète,
 * aucune durée ni distance n'est saisie
 */
export const PER_RIDE_ACTIVITIES = [ActivityType.DogSled];
